import { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import App from "./App";
import GoogleAnalytics from "./components/GoogleAnalytics";
import "./styles.css";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <StrictMode>
    <BrowserRouter basename={"/"}>
      <GoogleAnalytics />
      <App />
    </BrowserRouter>
  </StrictMode>
);
